import { Check, Globe, Monitor, Moon, Palette, Sun } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useTheme } from '@/components/theme-provider';
import { useTenantCurrent } from './api';

type Theme = 'light' | 'dark' | 'system';

const THEME_OPTIONS: Array<{
  value: Theme;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
}> = [
  { value: 'light', label: 'Claro', icon: Sun, description: 'Tema claro o tempo todo' },
  { value: 'dark', label: 'Escuro', icon: Moon, description: 'Tema escuro o tempo todo' },
  {
    value: 'system',
    label: 'Sistema',
    icon: Monitor,
    description: 'Acompanha a preferência do seu sistema operacional',
  },
];

export function PreferencesSection() {
  const { theme, setTheme } = useTheme();
  const tenantQuery = useTenantCurrent();

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Palette className="size-4" />
            Aparência
          </CardTitle>
          <CardDescription>Tema do painel — preferência salva neste navegador.</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3 sm:grid-cols-3">
            {THEME_OPTIONS.map((opt) => {
              const Icon = opt.icon;
              const active = theme === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => setTheme(opt.value)}
                  className={`flex flex-col items-start gap-2 rounded-lg border p-4 text-left transition-colors ${
                    active
                      ? 'border-primary bg-primary/5'
                      : 'border-border hover:bg-accent/40'
                  }`}
                >
                  <div className="flex w-full items-center justify-between">
                    <div
                      className={`flex size-8 items-center justify-center rounded-md ${
                        active ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
                      }`}
                    >
                      <Icon className="size-4" />
                    </div>
                    {active && <Check className="size-4 text-primary" />}
                  </div>
                  <div>
                    <p className="text-sm font-medium">{opt.label}</p>
                    <p className="text-xs text-muted-foreground">{opt.description}</p>
                  </div>
                </button>
              );
            })}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Globe className="size-4" />
            Idioma e fuso
          </CardTitle>
          <CardDescription>
            Definidos por empresa. Para alterar, peça a um administrador.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3 sm:grid-cols-2">
            <div className="rounded-lg border border-border p-4">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">Idioma</p>
              <p className="mt-1 text-sm font-medium">
                {tenantQuery.data?.locale === 'pt-BR' ? 'Português (Brasil)' : tenantQuery.data?.locale ?? '—'}
              </p>
            </div>
            <div className="rounded-lg border border-border p-4">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">Fuso horário</p>
              <p className="mt-1 text-sm font-medium">{tenantQuery.data?.timezone ?? '—'}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
